export default __webpack_public_path__ + "static/media/welness2.e871a5fb.jpeg";